import { Component, OnInit, ChangeDetectionStrategy, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-bulk-updates-dialog',
  templateUrl: './bulk-updates-dialog.component.html',
  styleUrls: ['./bulk-updates-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BulkUpdatesDialogComponent implements OnInit {

  changeList: string[] = [];
  warning: string; 

  constructor(
    private dialogRef: MatDialogRef<BulkUpdatesDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {

    this.changeList = data.changeList;
    this.warning = data.warning
  }

  ngOnInit() {
  }

  /**
   * Método chamado na resposta "Sim" do modal.
   *
   * @returns Retorna o boolean "true", indicando que o valor escolhido foi "Sim"
   */
  acceptChange() {
    this.dialogRef.close(true);
  }
}
